import React from 'react'
import './home.css'
import searchicon from '../components/resources/searchicon.png'

const Home = ()=> {
  let apikey='a6118566301a3003b453eb67f62d9008';
  const search =  async ()=> {
    const element = document.getElementsByClassName("searchboxarea")
    console.log(element[0])
    if (element[0].value ===""){
      return 0;
    } 
    let url = `https://api.openweathermap.org/data/2.5/weather?q=${element[0].value}&units=metric&appid=${apikey}`;
    let response = await fetch(url);
    let data= await response.json();
    const humidity =document.getElementsByClassName("humidity")
    const wind = document.getElementsByClassName("windspeed")
    const tempreture = document.getElementsByClassName("temp")
    const location = document.getElementsByClassName("wlocation")

    humidity[0].innerHTML= data.main.humidity+"%";
    wind[0].innerHTML=data.wind.speed+" knots"
    tempreture[0].innerHTML=data.main.temp+"\u00B0C"
    location[0].innerHTML=data.name;


  }
    return (
      
      <div className='mainbody'>
        
        <div className="appbody">
          <div className="searchbar">
            <div className="searchbox">
              <input type="text" name="" id="" className='searchboxarea' />

            </div>
            <div className="searchbtn" onClick={()=>{search()}} >
              <img src={searchicon} alt="" className='searchimg' />

            </div>
          </div>
          <div className="content">
            <div className="temp">
              <h1>22&deg;C</h1>
            </div>
            <div className="wlocation">
              <h3>LONDON</h3>

            </div>
          </div>
          <div className="lowercontent">
            <div className="humbox">
            <div className="humidity">
                15%
            </div>
            <div className="humlogo">Humidity percent</div></div>
            <div className="humbox">
            <div className="windspeed">
              33
            </div>
            <div className="humlogo"> Wind Speed</div></div>
          </div>
        </div>
      </div>
    )
  }


export default Home
